/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Node } from '../../core/models/Node';
import { SecurityRequirement } from '../../core/models/common/SecurityRequirement';

/**
 * @author Jakub Senko <jsenko@redhat.com>
 * @param {Node} parent
 * @class
 * @extends SecurityRequirement
 */
export abstract class AaiSecurityRequirement extends SecurityRequirement {
    public constructor(parent? : any) {
        if(((parent != null && parent instanceof <any>Node) || parent === null)) {
            let __args = arguments;
            super();
            (() => {
                if(parent != null) {
                    this._parent = parent;
                    this._ownerDocument = parent.ownerDocument();
                }
            })();
        } else if(parent === undefined) {
            let __args = arguments;
            super();
        } else throw new Error('invalid overload');
    }
}
AaiSecurityRequirement["__class"] = "io.apicurio.datamodels.asyncapi.models.AaiSecurityRequirement";
AaiSecurityRequirement["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




